export interface CoeditEditor {
  url: string
  operation: string | null
}

export const parseEditor = (value: string | null | undefined, operation: string): CoeditEditor | null => {
  try {
    if (!value) return null
    const url = new URL(value)
    return ['http:', 'https:'].includes(url.protocol) ? { url: url.href, operation } : null
  } catch {
    return null
  }
}
